const UnsettledReport = () => import('../screens/Reports/UnsettledReport/UnsettledReport.vue');
const BankUnsettledReport = () =>
  import('../screens/Reports/BankUnsettledReport/BankUnsettledReport.vue');
const PspDataReport = () => import('../screens/Reports/PspDataReport/PspDataReport.vue');

export default [
  {
    component: UnsettledReport,
    meta: {
      activeSidebarItemId: 'unsettled-amount-report',
      authority: 'merchant_unsettled_amount_report:view',
      pageTitle: 'Merchant Unsettled Amounts Report',
    },
    name: 'unsettled-amount-report',
    path: '/unsettled-amount-report',
  },
  {
    component: BankUnsettledReport,
    meta: {
      activeSidebarItemId: 'bank-unsettled-amount-report',
      authority: 'bank_unsettled_amount_report:view',
      pageTitle: 'Bank Unsettled Amounts Report',
    },
    name: 'bank-unsettled-amount-report',
    path: '/bank-unsettled-amount-report',
  },
  {
    component: PspDataReport,
    meta: {
      activeSidebarItemId: 'psp-data-report',
      pageTitle: 'PSP Data Report',
    },
    name: 'psp-data-report',
    path: '/psp-data-report',
  },
];
